import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { OrderBillDetailsBus } from "./OrderBillDetailsBus";
import { OrderBillPaymentsBus } from "./OrderBillPaymentsBus";
import { DateFunctions } from "../static/date-functions";
import { OrderBillBus } from "./OrderBillBus";

export class OrderBillParamBus extends BaseBus
{

    constructor(data: OrderBillParamBus = null) {
        super(data);

    }
    orderBills: OrderBillBus[];
}
